import React from "react";
import { RequireAuth, RedirectIfAuthed } from "../auth/guards";

const Home = React.lazy(() => import("../pages/Home"));
const About = React.lazy(() => import("../pages/About"));
const Finance = React.lazy(() => import("../pages/Finance"));
const Core = React.lazy(() => import("../pages/Core"));
const Robotics = React.lazy(() => import("../pages/Robotics"));
const Plans = React.lazy(() => import("../pages/Plans"));
const Docs = React.lazy(() => import("../pages/Docs"));
const SearchResultsPage = React.lazy(() => import("../pages/SearchResultsPage"));
const NotFoundPage = React.lazy(() => import("../pages/NotFoundPage"));
const Login = React.lazy(() => import("../pages/Login"));
const Register = React.lazy(() => import("../pages/Register"));
const VerifyEmail = React.lazy(() => import("../pages/VerifyEmail"));
const Account = React.lazy(() => import("../pages/auth/Account"));

// **************** Documentation Files **************** //
// Examples
const BasicExamplePage = React.lazy(() => import("../pages/docs/examples/BasicExample"));

// API
const ApiAuthPage = React.lazy(() => import("../pages/docs/api/Authentication"));
const ApiEndpointsPage = React.lazy(() => import("../pages/docs/api/Endpoints"));

// Financial Pages
const CompanyPage = React.lazy(() => import("../pages/CompanyPage"));
const MarketsPage = React.lazy(() => import("../pages/Markets"));
const SP500 = React.lazy(() => import("../pages/SP500"));
const CapDuel = React.lazy(() => import("../pages/CapDuel"));
const TreeMap = React.lazy(() => import("../pages/MarketTreeMap"));
const PerfBadges = React.lazy(() => import("../pages/SP500Performance"));
const FundamentalTrend = React.lazy(() => import("../pages/FundamentalTrend"));

const routes = [
  { path: "/", component: <Home /> },
  { path: "/login", component: <RedirectIfAuthed><Login /></RedirectIfAuthed> },
  { path: "/register", component: <RedirectIfAuthed><Register /></RedirectIfAuthed> },
  { path: "/account", component: <RequireAuth><Account /></RequireAuth> },
  { path: "/verify-email", component: <VerifyEmail /> },
  { path: "/about", component: <About /> },
  { path: "/finance", component: <Finance /> },
  { path: "/finance/core", component: <Core /> },
  { path: "/robotics", component: <Robotics /> },
  { path: "/plans", component: <Plans /> },
  { path: "/docs", component: <Docs /> },
  { path: "/docs/search", component: <SearchResultsPage /> },
  { path: "/docs/api/basic", component: <BasicExamplePage /> },
  { path: "/docs/api/auth", component: <ApiAuthPage /> },
  { path: "/docs/api/endpoints", component: <ApiEndpointsPage /> },
  { path: "/finance/overview/:ticker", component: <CompanyPage /> },
  { path: "/finance/markets", component: <MarketsPage /> },
  { path: "/finance/sp500", component: <SP500 /> },
  { path: "/finance/sp500/performance", component: <PerfBadges /> },
  { path: "/finance/duel", component: <CapDuel /> },
  { path: "/finance/treemap", component: <TreeMap /> },
  { path: "/finance/fundamentals/", component: <FundamentalTrend /> },
  { path: "*", component: <NotFoundPage /> },
];

export default routes;



